import { useQuery } from "@tanstack/react-query";
import useAxios from "./useAxios";

const fetchData = async (url, axiosInstance) => {
  const response = await axiosInstance.get(url);
  return response.data;
};
export const useFetchData = (queryKey, url,enabled=true) => {
  const axiosInstance = useAxios();

  return useQuery({
    queryKey, // React Query automatically handles caching
    queryFn: () => fetchData(url, axiosInstance),
    cacheTime: 0, // Disable cache for this query
    refetchOnWindowFocus: false, // Disable refetching on window focus
    staleTime: Infinity, // Prevent background refetchingenabled: onMount
    enabled, // Only run the query if the URL is provided
  });
};
